export enum GmlPointType {
  COORDINATES = 'COORDINATES',
  POINT_REFERENCE = 'POINT_REFERENCE',
  GEO_BORDER_POINT = 'GEO_BORDER_POINT'
}
